import axios from 'axios'
import { Api, AuthToken } from './consts'
import { push } from 'react-router-redux'
export const GET_PHOTOS = 'photos/GET_PHOTOS'
export const DELETE_PHOTO = 'photos/DELETE_PHOTO'
export const UPLOAD_PHOTOS = 'photos/UPLOAD_PHOTOS'
export const TOGGLE_UPLOADING = 'photos/TOGGLE_UPLOADING'
export const SAVE_ORDER = 'photos/SAVE_ORDER'

const initialState = {
    photos: [],
    uploading: false
}

export default (state = initialState, action) => {
    switch(action.type){
        case GET_PHOTOS:
            return {
                ...state,
                photos: action.payload
            }
        case DELETE_PHOTO:
            return {
                ...state,
                photos: state.photos.filter(photo => photo._id !== action.payload.id)
            }
        case UPLOAD_PHOTOS:
            return {
                ...state,
                photos: [ ...state.photos, ...action.payload ],
                uploading: false
            }
        case TOGGLE_UPLOADING:
            return {
                ...state,
                uploading: !state.uploading
            }
        case SAVE_ORDER:
            return {
                ...state,
                photos: action.payload
            }
        default:
            return state
    }
}

const get_photos = photos => ({
    type: GET_PHOTOS,
    payload: photos
})

const delete_photo = id => ({
    type: DELETE_PHOTO,
    payload: {id}
})

const upload_photos = photos => ({
    type: UPLOAD_PHOTOS,
    payload: photos
})

const toggle_uploading = () => ({
    type: TOGGLE_UPLOADING
})

const save_order = photos => ({
    type: SAVE_ORDER,
    payload: photos
})

export const getPhotos = () => {
    return dispatch => {
        axios.get(`${Api}/photos`)
            .then((response) => {
                dispatch(get_photos(response.data))
            })
            .catch((error) => {
                // Handle error
            })
    }
}

export const deletePhoto = id => {
    return dispatch => {
        axios.post(`${Api}/photos/delete`, {id})
            .then((response) => {
                dispatch(delete_photo(id))
            })
            .catch((error) => {
                console.log(error)
                // Handle error
            })
    }
}

export const uploadPhotos = ({ target: { files } }) => {
    let data = new FormData()
    for (const file of files) {
        data.append('photos', file, file.name);
    }
    return dispatch => {
        dispatch(toggle_uploading())
        axios.post(`${Api}/photos/upload`, data)
            .then((response) => {
                // window.location.reload()
                dispatch(upload_photos(response.data))
            })
            .catch((error) => {
                // Toggle error
            })
    }
}

export const saveOrder = photos => {
    return dispatch => {
        axios.post(`${Api}/photos/save_order`, photos)
            .then((response) => {
                dispatch(save_order(photos))
            })
            .catch((error) => {
                console.log(`Error!`)
            })
    }
}


// WEBPACK FOOTER //
// ./src/modules/photos.js